import { useQuery } from '@apollo/client';
import { useNotifications } from 'modules/notification';
import { EligibleFinanceProgramsResponse } from '@trnsact/trnsact-shared-types';
import { lenderDeskingApi } from './index';

interface Variables {
  accountId: string;
  creditSubmissionId: string;
}

export function useEligibleFinancePrograms({ accountId, creditSubmissionId }: Variables) {
  const { showNotification } = useNotifications();

  const { data, loading } = useQuery<{ eligibleFinancePrograms: EligibleFinanceProgramsResponse }, Variables>(
    lenderDeskingApi.getEligibleFinancePrograms,
    {
      variables: { accountId, creditSubmissionId },
      skip: !accountId || !creditSubmissionId,
      onError() {
        showNotification('Failed to load eligible finance programs', { type: 'error' });
      },
    }
  );

  return {
    isLoading: loading,
    eligiblePrograms: data?.eligibleFinancePrograms?.list ?? [],
  };
}
